module.exports = new __parcel__URL__("brickfilm.755320c4.jpeg").toString();